import React, { FC } from 'react'

import { SanityAccountDashboardPageFragment } from '../../../../graphql/gatsby'
import { DashboardFeaturedProductsBanner } from './page-sections/DashboardFeaturedProductsBanner'

export interface DashboardPageSectionsProps {
  sanityAccountDashboardPage: SanityAccountDashboardPageFragment['sanityAccountDashboardPage']
}

const DashboardPageSection: FC<{
  content: NonNullable<
    NonNullable<SanityAccountDashboardPageFragment['sanityAccountDashboardPage']>['content']
  >[number]
}> = ({ content }) => {
  switch (content?.__typename) {
    case 'SanityFeaturedProductsBanner':
      return <DashboardFeaturedProductsBanner featuredProductsBanner={content} />
    default:
      return null
  }
}

export const DashboardPageSections: FC<DashboardPageSectionsProps> = ({
  sanityAccountDashboardPage,
}) => {
  const dashboardPageSections = sanityAccountDashboardPage?.content ?? []
  return (
    <>
      {dashboardPageSections.map((content, index) => (
        <DashboardPageSection key={`dashboard-page-section-${index}`} content={content} />
      ))}
    </>
  )
}
